module.exports = __webpack_public_path__ + "files/3c4851c3273cb6d5cb0e9ac4f745d405.svg";